import { message } from "antd";
import { createAttachedSignature } from "crypto-pro";

/**
 * Проверка флешки с ЭЦП по отпечатку, если флешка с соответствующем отпечатком не вставлена, выдаст ошибку
 * @param thumbprint - отпечаток ЭЦП
 */
export const checkCSPFlash = async (thumbprint: string) => {
  try {
    await createAttachedSignature(thumbprint, "check");
  } catch (error: unknown) {
    if (error instanceof Error) {
      message.info("Флешка не найдена");
      throw new Error(error.message);
    }
  }
};
